import {ISortedPageRequest} from "../common/interfaces/IPageRequest";


export interface IDocumentRow {
    remoteDocumentId: number;
    documentId: number;
    documentNumber: string;
    documentDateCreated: string;
    locationName: string;
    remoteCardId: string;
    cardName?: string;
    productName: string;
    price: number;
    productQuantity: number;
    productAmountSum: number;
    vehicleNumber?: string;
    vehicleMileage?: string;
}
export interface IDocumentRowSum {
    customerId: number
    sum: number
    sumWithoutVat: number
    vatSum: number
}

export enum IDocumentRowSortFields {
    DOCUMENT_NUMBER = "DOCUMENT_NUMBER",
    DOCUMENT_DATE = "DOCUMENT_DATE",
    LOCATION = "LOCATION",
    REMOTE_CARD_ID = "REMOTE_CARD_ID",
    CARD_NAME = 'CARD_NAME',
    PRODUCT_NAME = "PRODUCT_NAME",
    PRICE = "PRICE",
    PRODUCT_QUANTITY = "PRODUCT_QUANTITY",
    PRODUCT_AMOUNT_SUM = "PRODUCT_AMOUNT_SUM"
}

export interface IDocumentRowRequest extends ISortedPageRequest<IDocumentRowSortFields> {
    limitToCard?: number;
    limitToCardName?: string;
    limitToLocation?: string;
    types?: string;
    documentDateCreatedStart?: string;
    documentDateCreatedEnd?: string;
    vehicleNumber?: string;
}

export enum DocumentRowFilterType {
  DATE = 'DATE',
  CARD = 'CARD',
  NAME = 'NAME',
  LOCATION = 'LOCATION',
  VEHICLE_NUMBER = 'VEHICLE_NUMBER'
}